import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { InvestmentInCompaniesService } from '../../../../modules/investment/incompanies/investment-incompanies.service';
import {
  InvestmentInCompaniesDepositsModel,
  InvestmentInCompaniesModel
} from '../../../../modules/investment/incompanies/investment-incompanies.model';
import { SearchPayload } from '../../../shared/utils/table-types';
import { InvestmentListResult, requestInvestmentList } from '../../shared/investment-list.util';
import { InvestmentCompanyListSummary } from '../models/investment-company.model';

@Injectable({ providedIn: 'root' })
export class InvestmentCompanyEntityService {

  constructor(private http: HttpClient, private inCompaniesService: InvestmentInCompaniesService) { }

  list(payload: SearchPayload): Promise<InvestmentListResult<InvestmentInCompaniesModel, InvestmentCompanyListSummary>> {
    return requestInvestmentList<InvestmentInCompaniesModel, InvestmentCompanyListSummary>(this.http, '/api/v2/investment-companies/list', payload, 'No se pudo cargar la lista de inversiones en empresas');
  }

  get(uid: string): Promise<InvestmentInCompaniesModel> {
    return this.inCompaniesService.get(uid).then(item => {
      if (!item) throw new Error();
      return item;
    });
  }

  deposits(uid: string): Promise<InvestmentInCompaniesDepositsModel[]> {
    return this.inCompaniesService.depositList(uid);
  }

  create(payload: InvestmentInCompaniesModel): Promise<void> {
    return this.inCompaniesService.add(payload).then(ok => this.ensureOk(ok));
  }

  update(uid: string, payload: InvestmentInCompaniesModel): Promise<void> {
    return this.inCompaniesService.edit({ ...payload, uid }).then(ok => this.ensureOk(ok));
  }

  delete(uid: string): Promise<void> {
    return this.inCompaniesService.delete(uid).then(ok => this.ensureOk(ok));
  }

  private ensureOk(ok: unknown): void {
    if (ok !== true) throw new Error();
  }
}
